<template>
    <div class="steps">
        <div
            v-for="(item, index) in stepItem"
            :key="item.val"
            :style="`flex-basis: ${100 / stepItem.length}%`"
            :class="`item-container ${active >= item.val ? 'active-step' : ''}`"
        >
            <div class="item">
                <span class="label">{{ item.name }}</span>
                <div class="state">
                    <van-icon name="checked" />
                    <div class="none" />
                </div>
            </div>
            <div :class="`line ${active > item.val ? 'active-line' : ''}`" v-if="stepItem.length - 1 > index" />
        </div>
    </div>
</template>
<script>
export default {
    props: ['stepItem', 'active'],
    created() {},
}
</script>
<style lang="scss" scoped>
.steps {
    display: flex;
    padding: 0 12px;
    .item-container {
        position: relative;
    }
    .item {
        font-size: 18px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        z-index: 2;
        .state {
            padding-top: 8px;
        }
        .none {
            border-radius: 50%;
            border: 8px solid #999;
            display: block;
        }
        .van-icon {
            display: none;
            color: #07c160;
        }
    }
    .line {
        background: #efefef;
        width: calc(100% - 24px);
        height: 3px;
        position: absolute;
        z-index: 1;
        bottom: 7px;
        left: calc(50% + 12px);
    }
    .active-line {
        background: #07c160;
    }
}
.active-step {
    .item {
        .label {
            color: #07c160;
        }
        .none {
            display: none;
        }
        .van-icon {
            display: block;
        }
    }
}
@media screen and (max-width: 1000px) {
    .steps {
        padding: 0;
        .item {
            font-size: 15px;
            .state {
                padding-top: 6px;
            }
            .none {
                border: 6px solid #999;
            }
        }
        .line {
            height: 2px;
            bottom: 6px;
        }
    }
}
</style>
